var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBibliotheekOpen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 508.63 327.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: #707e80;\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-51);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-17);\n      }\n\n      .cls-5 {\n        fill: #e8d8bb;\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-43);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-15);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-58);\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-18);\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient-56);\n      }\n\n      .cls-11 {\n        fill: url(#linear-gradient-40);\n      }\n\n      .cls-12 {\n        fill: #455a64;\n      }\n\n      .cls-13 {\n        fill: url(#linear-gradient-52);\n      }\n\n      .cls-14 {\n        fill: url(#linear-gradient-28);\n      }\n\n      .cls-15 {\n        fill: url(#linear-gradient-14);\n      }\n\n      .cls-16 {\n        fill: url(#linear-gradient-36);\n      }\n\n      .cls-17 {\n        fill: url(#linear-gradient-20);\n      }\n\n      .cls-18 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-19 {\n        fill: url(#linear-gradient-53);\n      }\n\n      .cls-20 {\n        fill: #a6a6a6;\n      }\n\n      .cls-21 {\n        fill: url(#linear-gradient-35);\n      }\n\n      .cls-22 {\n        fill: url(#linear-gradient-48);\n      }\n\n      .cls-23 {\n        fill: url(#linear-gradient-32);\n      }\n\n      .cls-24 {\n        fill: url(#linear-gradient-11);\n      }\n\n      .cls-25 {\n        fill: url(#linear-gradient-50);\n      }\n\n      .cls-26 {\n        fill: #7a7161;\n      }\n\n      .cls-27 {\n        fill: url(#linear-gradient-39);\n      }\n\n      .cls-28 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-29 {\n        fill: url(#linear-gradient-59);\n      }\n\n      .cls-30 {\n        fill: url(#linear-gradient-49);\n      }\n\n      .cls-31 {\n        fill: url(#linear-gradient-37);\n      }\n\n      .cls-32 {\n        fill: url(#linear-gradient-16);\n      }\n\n      .cls-33 {\n        fill: #e7d7ba;\n      }\n\n      .cls-34 {\n        fill: url(#linear-gradient-31);\n      }\n\n      .cls-35 {\n        fill: url(#linear-gradient-41);\n      }\n\n      .cls-36 {\n        fill: url(#linear-gradient-21);\n      }\n\n      .cls-37 {\n        fill: url(#linear-gradient-25);\n      }\n\n      .cls-38 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-39 {\n        fill: url(#linear-gradient-54);\n      }\n\n      .cls-40 {\n        fill: url(#linear-gradient-45);\n      }\n\n      .cls-41 {\n        fill: url(#linear-gradient-55);\n      }\n\n      .cls-42 {\n        fill: #ebebeb;\n      }\n\n      .cls-43 {\n        fill: url(#linear-gradient-34);\n      }\n\n      .cls-44 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-45 {\n        fill: url(#linear-gradient-24);\n      }\n\n      .cls-46 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-47 {\n        fill: url(#linear-gradient-22);\n      }\n\n      .cls-48 {\n        fill: url(#linear-gradient-42);\n      }\n\n      .cls-49 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-50 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-51 {\n        fill: url(#linear-gradient-27);\n      }\n\n      .cls-52 {\n        fill: url(#linear-gradient-33);\n      }\n\n      .cls-53 {\n        fill: url(#linear-gradient-38);\n      }\n\n      .cls-54 {\n        fill: url(#linear-gradient-29);\n      }\n\n      .cls-55 {\n        fill: url(#linear-gradient-30);\n      }\n\n      .cls-56 {\n        fill: url(#linear-gradient-23);\n      }\n\n      .cls-57 {\n        fill: url(#linear-gradient-19);\n      }\n\n      .cls-58 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-59 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-60 {\n        fill: url(#linear-gradient-44);\n      }\n\n      .cls-61 {\n        fill: url(#linear-gradient-57);\n      }\n\n      .cls-62 {\n        fill: url(#linear-gradient-47);\n      }\n\n      .cls-63 {\n        fill: url(#linear-gradient-46);\n      }\n\n      .cls-64 {\n        fill: url(#linear-gradient-12);\n      }\n\n      .cls-65 {\n        fill: url(#linear-gradient-13);\n      }\n\n      .cls-66 {\n        fill: url(#linear-gradient-26);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 26.73,
    y1: 203.58,
    x2: 481.9,
    y2: 203.58,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fef7e3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fef7e3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 0,
    y1: 310.24,
    x2: 508.63,
    y2: 310.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9c927f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9c927f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 14.27,
    y1: 101.47,
    x2: 496.54,
    y2: 101.47,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 255.4,
    y1: 312.9,
    x2: 255.4,
    y2: 324.98,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e7d7ba"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b8ad97"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 255.4,
    y1: 294.6,
    x2: 255.4,
    y2: 310.03,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 142.97,
    y1: 310.2,
    x2: 155.22,
    y2: 310.2,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 149.8,
    y1: 316.73,
    x2: 162.06,
    y2: 316.73,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 326.01,
    y1: 301.08,
    x2: 338.26,
    y2: 301.08,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 332.85,
    y1: 307.61,
    x2: 345.1,
    y2: 307.61,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 2096.62,
    y1: 313.47,
    x2: 2108.87,
    y2: 313.47,
    gradientTransform: "translate(2484.5) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 2103.45,
    y1: 320,
    x2: 2115.71,
    y2: 320,
    gradientTransform: "translate(2484.5) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 173.56,
    y1: 301.08,
    x2: 185.81,
    y2: 301.08,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 258.08,
    y1: 238.83,
    x2: 299.02,
    y2: 238.83,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 6125.94,
    y1: 238.83,
    x2: 6166.89,
    y2: 238.83,
    gradientTransform: "translate(6383.66) rotate(-180) scale(1 -1)",
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 403.28,
    y1: 221.02,
    x2: 466.36,
    y2: 221.02,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 406.87,
    y1: 211.13,
    x2: 462.73,
    y2: 211.13,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 422.8,
    y1: 195.03,
    x2: 426.44,
    y2: 195.03,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 443.14,
    y1: 195.04,
    x2: 446.78,
    y2: 195.04,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 321.38,
    y1: 221.02,
    x2: 384.46,
    y2: 221.02,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 324.97,
    y1: 211.13,
    x2: 380.83,
    y2: 211.13,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 340.9,
    y1: 195.03,
    x2: 344.54,
    y2: 195.03,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 361.24,
    y1: 195.04,
    x2: 364.88,
    y2: 195.04,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 131.33,
    y1: 221.02,
    x2: 194.41,
    y2: 221.02,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 134.91,
    y1: 211.13,
    x2: 190.77,
    y2: 211.13,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 150.85,
    y1: 195.03,
    x2: 154.48,
    y2: 195.03,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 171.18,
    y1: 195.04,
    x2: 174.82,
    y2: 195.04,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 50.66,
    y1: 221.02,
    x2: 113.74,
    y2: 221.02,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 54.25,
    y1: 211.13,
    x2: 110.11,
    y2: 211.13,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 70.18,
    y1: 195.03,
    x2: 73.82,
    y2: 195.03,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 90.52,
    y1: 195.04,
    x2: 94.15,
    y2: 195.04,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 127.92,
    y1: 125.11,
    x2: 156.96,
    y2: 125.11,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 142.44,
    y1: 278.95,
    x2: 142.44,
    y2: 291.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9c927f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7a7161"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 128.81,
    y1: 269.16,
    x2: 156.07,
    y2: 269.16,
    xlinkHref: "#linear-gradient-32"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 129.18,
    y1: 197.13,
    x2: 155.7,
    y2: 197.13,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 176.92,
    y1: 125.11,
    x2: 205.96,
    y2: 125.11,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 191.44,
    y1: 278.47,
    x2: 191.44,
    y2: 290.99,
    xlinkHref: "#linear-gradient-32"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 177.81,
    y1: 269.16,
    x2: 205.07,
    y2: 269.16,
    xlinkHref: "#linear-gradient-32"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-38",
    x1: 178.18,
    y1: 197.13,
    x2: 204.7,
    y2: 197.13,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-39",
    x1: 311.49,
    y1: 125.11,
    x2: 340.53,
    y2: 125.11,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-40",
    x1: 326.01,
    y1: 278.71,
    x2: 326.01,
    y2: 291.72,
    xlinkHref: "#linear-gradient-32"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-41",
    x1: 312.38,
    y1: 269.16,
    x2: 339.64,
    y2: 269.16,
    xlinkHref: "#linear-gradient-32"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-42",
    x1: 312.75,
    y1: 197.13,
    x2: 339.27,
    y2: 197.13,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-43",
    x1: 359.55,
    y1: 125.11,
    x2: 388.59,
    y2: 125.11,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-44",
    x1: 374.07,
    y1: 278.71,
    x2: 374.07,
    y2: 291.72,
    xlinkHref: "#linear-gradient-32"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-45",
    x1: 360.44,
    y1: 269.16,
    x2: 387.7,
    y2: 269.16,
    xlinkHref: "#linear-gradient-32"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-46",
    x1: 360.81,
    y1: 197.13,
    x2: 387.33,
    y2: 197.13,
    xlinkHref: "#linear-gradient-4"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-47",
    x1: 58.81,
    y1: 31.34,
    x2: 449.83,
    y2: 31.34,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-48",
    x1: 82.97,
    y1: 79.66,
    x2: 425.66,
    y2: 79.66,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-49",
    x1: 166.62,
    y1: 79.66,
    x2: 181.36,
    y2: 79.66,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-50",
    x1: 185.14,
    y1: 79.66,
    x2: 190.25,
    y2: 79.66,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-51",
    x1: 194.68,
    y1: 79.66,
    x2: 209.43,
    y2: 79.66,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-52",
    x1: 213.2,
    y1: 79.66,
    x2: 224.57,
    y2: 79.66,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-53",
    x1: 228.4,
    y1: 79.66,
    x2: 233.52,
    y2: 79.66,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-54",
    x1: 237.28,
    y1: 79.66,
    x2: 253.45,
    y2: 79.66,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-55",
    x1: 256.27,
    y1: 79.66,
    x2: 269.6,
    y2: 79.66,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-56",
    x1: 273.2,
    y1: 79.66,
    x2: 288.4,
    y2: 79.66,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-57",
    x1: 292.83,
    y1: 79.66,
    x2: 305.53,
    y2: 79.66,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-58",
    x1: 309.72,
    y1: 79.66,
    x2: 322.42,
    y2: 79.66,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-59",
    x1: 326.6,
    y1: 79.66,
    x2: 342.02,
    y2: 79.66,
    xlinkHref: "#linear-gradient-2"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: 26.73,
    y: 98.72,
    width: 455.17,
    height: 209.72
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 293.27,
    width: 508.63,
    height: 33.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 118.68,
    y: 293.27,
    width: 281.15,
    height: 33.96
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 14.27,
    y: 96.63,
    width: 482.27,
    height: 9.68
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 189.91,
    y: 310.24,
    width: 130.98,
    height: 16.98
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 199.13,
    y: 293.27,
    width: 112.54,
    height: 16.98
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 67.51,
    y: 144.01,
    width: 12.26,
    height: 5.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 74.35,
    y: 150.54,
    width: 12.26,
    height: 5.18
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 14.27,
    y: 301.76,
    width: 12.26,
    height: 5.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 21.1,
    y: 308.28,
    width: 12.26,
    height: 5.18
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 421.91,
    y: 310.2,
    width: 12.26,
    height: 5.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 415.08,
    y: 316.73,
    width: 12.26,
    height: 5.18
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 142.97,
    y: 307.61,
    width: 12.26,
    height: 5.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 149.8,
    y: 314.14,
    width: 12.26,
    height: 5.18
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 326.01,
    y: 298.49,
    width: 12.26,
    height: 5.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 332.85,
    y: 305.02,
    width: 12.26,
    height: 5.18
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 375.63,
    y: 310.88,
    width: 12.26,
    height: 5.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 368.79,
    y: 317.41,
    width: 12.26,
    height: 5.18
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 268.17,
    y: 170.37,
    width: 12.26,
    height: 5.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 275.01,
    y: 176.9,
    width: 12.26,
    height: 5.18
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 485.7,
    y: 305.02,
    width: 12.26,
    height: 5.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 492.54,
    y: 311.55,
    width: 12.26,
    height: 5.18
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 415.73,
    y: 273.81,
    width: 12.26,
    height: 5.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 422.57,
    y: 280.34,
    width: 12.26,
    height: 5.18
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 397.44,
    y: 144.01,
    width: 12.26,
    height: 5.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 390.6,
    y: 150.54,
    width: 12.26,
    height: 5.18
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 177.85,
    y: 161.37,
    width: 12.26,
    height: 5.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 171.02,
    y: 167.9,
    width: 12.26,
    height: 5.18
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 83.89,
    y: 173.63,
    width: 12.26,
    height: 5.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 80.48,
    y: 271.22,
    width: 12.26,
    height: 5.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 69.6,
    y: 316.14,
    width: 12.26,
    height: 5.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 173.56,
    y: 298.49,
    width: 12.26,
    height: 5.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 95.38,
    y: 301.76,
    width: 12.26,
    height: 5.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 249.5,
    y: 138.14,
    width: 12.26,
    height: 5.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 308.63,
    y: 150.54,
    width: 12.26,
    height: 5.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 437.57,
    y: 173.63,
    width: 12.26,
    height: 5.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 449.83,
    y: 298.49,
    width: 12.26,
    height: 5.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 6,
    y: 106.46,
    width: 498.79,
    height: 11.54
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: 258.08,
    y: 184.4,
    width: 40.95,
    height: 108.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 264.17,
    y: 191.49,
    width: 28.77,
    height: 73.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 260.35,
    y: 240.88,
    width: 1.99,
    height: 12.24
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "292.93 191.49 292.93 197.94 264.17 230.66 264.17 215.16 284.97 191.49 292.93 191.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "292.93 225.3 292.93 240.78 271.78 264.9 264.17 264.9 264.17 258.06 292.93 225.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "292.93 218.5 292.93 221.77 264.17 254.54 264.17 251.26 292.93 218.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "282.08 191.49 264.17 211.86 264.17 205.45 276.44 191.49 282.08 191.49"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 264.17,
    y: 244.4,
    width: 28.77,
    height: 5.21
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 216.77,
    y: 184.4,
    width: 40.95,
    height: 108.87
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 222.86,
    y: 191.49,
    width: 28.77,
    height: 73.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 253.45,
    y: 240.88,
    width: 1.99,
    height: 12.24
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "251.62 191.49 251.62 197.94 222.86 230.66 222.86 215.16 243.66 191.49 251.62 191.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "251.62 225.3 251.62 240.78 230.47 264.9 222.86 264.9 222.86 258.06 251.62 225.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "251.62 218.5 251.62 221.77 222.86 254.54 222.86 251.26 251.62 218.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "240.77 191.49 222.86 211.86 222.86 205.45 235.13 191.49 240.77 191.49"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 222.86,
    y: 244.4,
    width: 28.77,
    height: 5.21
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m466.36,209.83v53.92h-63.08v-53.92c0-17.42,14.12-31.54,31.54-31.54s31.54,14.12,31.54,31.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m462.68,209.83v50.28h-55.81v-50.28c-.38-15.43,11.82-28.23,27.25-28.61,15.43-.38,28.23,11.82,28.61,27.25.01.45.01.91,0,1.36h-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m462.68,209.83v50.28h-55.81v-50.28c-.03-15.4,12.44-27.91,27.84-27.94.03,0,.06,0,.08,0,.9,0,1.78,0,2.64.13,8.82.83,16.72,5.81,21.28,13.4,1,1.63,1.82,3.37,2.44,5.18.37.99.66,2.02.88,3.05.45,2.03.67,4.1.65,6.18Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m458.71,195.42l-51.84,51.83v-18.56l42.61-42.61c3.78,2.33,6.94,5.54,9.23,9.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m462.03,203.65l-55.16,55.16v-3.93l54.28-54.28c.37.99.66,2.02.88,3.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m437.43,182.02l-30.56,30.56v-2.76c0-1.83.18-3.66.53-5.46l21.95-21.95c1.79-.35,3.62-.53,5.44-.53.9,0,1.78.05,2.64.13Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 406.87,
    y: 209.31,
    width: 55.86,
    height: 3.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 422.8,
    y: 180.74,
    width: 3.64,
    height: 28.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 443.14,
    y: 180.76,
    width: 3.64,
    height: 28.57
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "m384.46,209.83v53.92h-63.08v-53.92c0-17.42,14.12-31.54,31.54-31.54s31.54,14.12,31.54,31.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m380.78,209.83v50.28h-55.81v-50.28c-.38-15.43,11.82-28.23,27.25-28.61,15.43-.38,28.23,11.82,28.61,27.25.01.45.01.91,0,1.36h-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m380.78,209.83v50.28h-55.81v-50.28c-.03-15.4,12.44-27.91,27.84-27.94.03,0,.06,0,.08,0,.9,0,1.78,0,2.64.13,8.82.83,16.72,5.81,21.28,13.4,1,1.63,1.82,3.37,2.44,5.18.37.99.66,2.02.88,3.05.45,2.03.67,4.1.65,6.18Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m376.81,195.42l-51.84,51.83v-18.56l42.61-42.61c3.78,2.33,6.94,5.54,9.23,9.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m380.13,203.65l-55.16,55.16v-3.93l54.28-54.28c.37.99.66,2.02.88,3.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m355.53,182.02l-30.56,30.56v-2.76c0-1.83.18-3.66.53-5.46l21.95-21.95c1.79-.35,3.62-.53,5.44-.53.9,0,1.78.05,2.64.13Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 324.97,
    y: 209.31,
    width: 55.86,
    height: 3.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 340.9,
    y: 180.74,
    width: 3.64,
    height: 28.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 361.24,
    y: 180.76,
    width: 3.64,
    height: 28.57
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "m194.41,209.83v53.92h-63.08v-53.92c0-17.42,14.12-31.54,31.54-31.54s31.54,14.12,31.54,31.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m190.72,209.83v50.28h-55.81v-50.28c-.38-15.43,11.82-28.23,27.25-28.61,15.43-.38,28.23,11.82,28.61,27.25.01.45.01.91,0,1.36h-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m190.72,209.83v50.28h-55.81v-50.28c-.03-15.4,12.44-27.91,27.84-27.94.03,0,.06,0,.08,0,.9,0,1.78,0,2.64.13,8.82.83,16.72,5.81,21.28,13.4,1,1.63,1.82,3.37,2.44,5.18.37.99.66,2.02.88,3.05.45,2.03.67,4.1.65,6.18Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m186.75,195.42l-51.84,51.83v-18.56l42.61-42.61c3.78,2.33,6.94,5.54,9.23,9.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m190.07,203.65l-55.16,55.16v-3.93l54.28-54.28c.37.99.66,2.02.88,3.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m165.47,182.02l-30.56,30.56v-2.76c0-1.83.18-3.66.53-5.46l21.95-21.95c1.79-.35,3.62-.53,5.44-.53.9,0,1.78.05,2.64.13Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 134.91,
    y: 209.31,
    width: 55.86,
    height: 3.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 150.85,
    y: 180.74,
    width: 3.64,
    height: 28.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-66",
    x: 171.18,
    y: 180.76,
    width: 3.64,
    height: 28.57
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "m113.74,209.83v53.92h-63.08v-53.92c0-17.42,14.12-31.54,31.54-31.54s31.54,14.12,31.54,31.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m110.06,209.83v50.28h-55.81v-50.28c-.38-15.43,11.82-28.23,27.25-28.61,15.43-.38,28.23,11.82,28.61,27.25.01.45.01.91,0,1.36h-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "m110.06,209.83v50.28h-55.81v-50.28c-.03-15.4,12.44-27.91,27.84-27.94.03,0,.06,0,.08,0,.9,0,1.78,0,2.64.13,8.82.83,16.72,5.81,21.28,13.4,1,1.63,1.82,3.37,2.44,5.18.37.99.66,2.02.88,3.05.45,2.03.67,4.1.65,6.18Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m106.09,195.42l-51.84,51.83v-18.56l42.61-42.61c3.78,2.33,6.94,5.54,9.23,9.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m109.41,203.65l-55.16,55.16v-3.93l54.28-54.28c.37.99.66,2.02.88,3.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m84.81,182.02l-30.56,30.56v-2.76c0-1.83.18-3.66.53-5.46l21.95-21.95c1.79-.35,3.62-.53,5.44-.53.9,0,1.78.05,2.64.13Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 54.25,
    y: 209.31,
    width: 55.86,
    height: 3.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 70.18,
    y: 180.74,
    width: 3.64,
    height: 28.57
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 90.52,
    y: 180.76,
    width: 3.64,
    height: 28.57
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 127.92,
    y: 117.08,
    width: 29.04,
    height: 16.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 122.53,
    y: 277.2,
    width: 39.82,
    height: 16.07
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "156.07 277.2 128.81 277.2 129.18 261.13 155.7 261.13 156.07 277.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-43",
    points: "155.7 261.13 129.18 261.13 132.16 133.14 152.73 133.14 155.7 261.13"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 176.92,
    y: 117.08,
    width: 29.04,
    height: 16.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 171.53,
    y: 277.2,
    width: 39.82,
    height: 16.07
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "205.07 277.2 177.81 277.2 178.18 261.13 204.7 261.13 205.07 277.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-53",
    points: "204.7 261.13 178.18 261.13 181.16 133.14 201.73 133.14 204.7 261.13"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 311.49,
    y: 117.08,
    width: 29.04,
    height: 16.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 306.1,
    y: 277.2,
    width: 39.82,
    height: 16.07
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "339.64 277.2 312.38 277.2 312.75 261.13 339.27 261.13 339.64 277.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-48",
    points: "339.27 261.13 312.75 261.13 315.72 133.14 336.29 133.14 339.27 261.13"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 359.55,
    y: 117.08,
    width: 29.04,
    height: 16.07
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 354.16,
    y: 277.2,
    width: 39.82,
    height: 16.07
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "387.7 277.2 360.44 277.2 360.81 261.13 387.33 261.13 387.7 277.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-63",
    points: "387.33 261.13 360.81 261.13 363.78 133.14 384.35 133.14 387.33 261.13"
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "58.81 62.68 254.32 0 449.83 62.68 58.81 62.68"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "128.63 51.85 254.32 11.56 380.01 51.85 128.63 51.85"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 82.97,
    y: 62.68,
    width: 342.69,
    height: 33.95
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "m181.36,83.29c0,2.9-2.46,4.19-6.12,4.19h-8.62v-15.64h8.4c3.65,0,5.97,1.16,5.97,4.19,0,1.97-.77,3.28-2.34,3.63,1.63.17,2.71,1.62,2.71,3.63Zm-6.69-5.33c.79,0,1.36-.52,1.36-1.42s-.57-1.43-1.43-1.43h-2.87v2.85h2.94Zm.15,6.13c.87,0,1.4-.5,1.4-1.42s-.56-1.42-1.4-1.42h-3.08v2.84h3.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "m190.25,87.47h-5.11v-15.64h5.11v15.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m209.43,83.29c0,2.9-2.46,4.19-6.12,4.19h-8.62v-15.64h8.4c3.65,0,5.98,1.16,5.98,4.19,0,1.97-.77,3.28-2.35,3.63,1.63.17,2.71,1.62,2.71,3.63Zm-6.69-5.33c.79,0,1.36-.52,1.36-1.42s-.57-1.43-1.43-1.43h-2.87v2.85h2.94Zm.15,6.13c.87,0,1.4-.5,1.4-1.42s-.56-1.42-1.4-1.42h-3.08v2.84h3.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m224.57,83.49v3.99h-11.37v-15.64h5.11v11.65h6.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m233.52,87.47h-5.11v-15.64h5.11v15.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "m237.28,79.66c0-5.47,3.16-8.13,8.07-8.13s8.1,2.66,8.1,8.13-3.17,8.13-8.1,8.13-8.07-2.66-8.07-8.13Zm8.07,4.12c1.82,0,2.98-1.26,2.98-4.12s-1.16-4.12-2.98-4.12-2.97,1.26-2.97,4.12,1.16,4.12,2.97,4.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "m269.6,75.82h-4.11v11.65h-5.1v-11.65h-4.12v-3.99h13.34v3.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "m288.4,71.84v15.64h-5.1v-5.83h-4.98v5.83h-5.11v-15.64h5.11v5.83h4.98v-5.83h5.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "m297.94,75.82v2.14h6.33v3.37h-6.33v2.14h7.58v3.99h-12.7v-15.64h12.7v3.99h-7.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m314.83,75.82v2.14h6.33v3.37h-6.33v2.14h7.58v3.99h-12.7v-15.64h12.7v3.99h-7.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "m331.72,78.4l4.4-6.57h5.8l-5.5,7.82,5.6,7.82h-5.9l-4.4-6.57v6.57h-5.11v-15.64h5.11v6.57Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 384.62,
    y: 72.1,
    width: 12.26,
    height: 5.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 377.78,
    y: 78.63,
    width: 12.26,
    height: 5.18
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 109.41,
    y: 69.51,
    width: 12.26,
    height: 5.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 132.84,
    y: 85.19,
    width: 12.26,
    height: 5.18
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 138.97,
    y: 78.63,
    width: 12.26,
    height: 5.18
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBibliotheekOpen);
export default __webpack_public_path__ + "static/media/bibliotheek-open.6f9b61f7a15f160aa816b93762fdfe95.svg";
export { ForwardRef as ReactComponent };